module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-account-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "155px"
          },
          attrs: {
            "placeholder": "账号 / 姓名 / 企业",
            "clearable": ""
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getUser(1)
            }
          },
          model: {
            value: (_vm.searchName),
            callback: function($$v) {
              _vm.searchName = $$v
            },
            expression: "searchName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "placeholder": "用户类型",
            "clearable": ""
          },
          model: {
            value: (_vm.isCompanyUser),
            callback: function($$v) {
              _vm.isCompanyUser = $$v
            },
            expression: "isCompanyUser"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "个人用户",
            "value": "1"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "企业用户",
            "value": "2"
          }
        })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "开始日期"
          },
          model: {
            value: (_vm.souchs.fromtime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "fromtime", $$v)
            },
            expression: "souchs.fromtime"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "format": "yyyy-MM-dd",
            "value-format": "yyyy-MM-dd",
            "type": "date",
            "placeholder": "结束日期"
          },
          model: {
            value: (_vm.souchs.totime),
            callback: function($$v) {
              _vm.$set(_vm.souchs, "totime", $$v)
            },
            expression: "souchs.totime"
          }
        })], 1), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', {
          staticStyle: {
            "width": "130px"
          }
        }, [_c('SelectCommon', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "客户经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.managerAdminuser
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'managerAdminuser'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "130px"
          },
          attrs: {
            "placeholder": "客户成功经理",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 3
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.successfulManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'successfulManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-form-item', [_c('SelectCommon', {
          staticStyle: {
            "width": "130px"
          },
          attrs: {
            "placeholder": "经销商",
            "clearable": true,
            "apiPath": "/tbAdminuser/list",
            "params": {
              type: 4
            },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "defaultVal": _vm.agencyManager
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommonFilter(value, datas, 'agencyManager'); }
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-select', {
          staticStyle: {
            "width": "120px"
          },
          attrs: {
            "placeholder": "是否分配",
            "clearable": ""
          },
          model: {
            value: (_vm.distributionStatus),
            callback: function($$v) {
              _vm.distributionStatus = $$v
            },
            expression: "distributionStatus"
          }
        }, _vm._l((_vm.distribution), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getUser(1)
            }
          }
        }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.addUser(1)
            }
          }
        }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.addUser(2)
            }
          }
        }, [_vm._v("批量导入")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('a', {
          attrs: {
            "href": _vm.downHref
          }
        }, [_vm._v("下载模板")])]), _vm._v(" "), (_vm.userInfo.type == 1) ? _c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('a', {
          attrs: {
            "href": _vm.downHrefExcel
          }
        }, [_vm._v("导出")])]) : _vm._e(), _vm._v(" "), _c('input', {
          ref: "clearFileModal",
          staticStyle: {
            "display": "none"
          },
          attrs: {
            "type": "file",
            "id": "uploadwxsModal",
            "name": "file",
            "accept": "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          },
          on: {
            "change": function($event) {
              return _vm.fileInputChange($event)
            }
          }
        })], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags), function(tag) {
          return _c('el-tag', {
            key: tag,
            attrs: {
              "closable": "",
              "disable-transitions": false
            },
            on: {
              "close": function($event) {
                return _vm.handleClose(tag)
              }
            }
          }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
        }), _vm._v(" "), (_vm.dynamicTags != '') ? _c('el-button', {
          staticClass: "button-new-tag",
          attrs: {
            "size": "small"
          },
          on: {
            "click": _vm.delTags
          }
        }, [_vm._v("清除标签")]) : _vm._e()], 2)]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          attrs: {
            "data": _vm.users,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "sort-change": _vm.handleSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "60"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "phone",
            "label": "账号",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "name",
            "label": "姓名",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "point",
            "label": "积分",
            "width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v(" " + _vm._s(scope.row.point || "-") + " ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "registertime",
            "label": "注册日期",
            "sortable": "custom"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "softtype",
            "label": "软件类型",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "productTypeName",
            "label": "类型"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.productType === '1') ? _c('div', {
                staticClass: "purple"
              }, [_vm._v("\n            " + _vm._s(scope.row.productTypeName) + "\n          ")]) : (scope.row.productType === '2') ? _c('div', {
                staticClass: "blue"
              }, [_vm._v("\n            " + _vm._s(scope.row.productTypeName) + "\n          ")]) : _c('div', {
                staticClass: "gray"
              }, [_vm._v(_vm._s(scope.row.productTypeName))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "company",
            "label": "企业",
            "min-width": "180",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "客户经理",
            "min-width": "100",
            "sortable": "custom",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.adminName || "-") + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "客户成功经理",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.successfulManagerName || "-") + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "经销商",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.agencyManagerName || "-") + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "adminName",
            "label": "是否联系过",
            "min-width": "100",
            "sortable": "hasNote",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n          " + _vm._s(scope.row.hasNote == 0 ? "否" : "是") + "\n        ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          staticStyle: {
            "text-algin": "center"
          },
          attrs: {
            "label": "操作",
            "min-width": "100"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.readUser(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "编辑",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconEdit",
                on: {
                  "click": function($event) {
                    return _vm.handleEdit0(scope.$index, scope.row)
                  }
                }
              })]), _vm._v(" "), (scope.row.canYouDel == 1) ? _c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "删除",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont icondelete",
                on: {
                  "click": function($event) {
                    return _vm.handledel(scope.$index, scope.row)
                  }
                }
              })]) : _vm._e()], 1)]
            }
          }])
        })], 1), _vm._v(" "), (_vm.editFormVisible0) ? _c('el-dialog', {
          staticClass: "model-edit model-user-box",
          attrs: {
            "width": "850px",
            "title": _vm.asTitle,
            "visible": _vm.editFormVisible0,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible0 = $event
            },
            "close": _vm.dialogClose
          }
        }, [_c('el-row', {
          attrs: {
            "gutter": 24
          }
        }, [_c('el-form', {
          ref: "editForm0",
          attrs: {
            "model": _vm.editForm0,
            "label-width": "100px",
            "rules": _vm.rules
          }
        }, [(_vm.modalType != 2) ? _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "账号",
            "prop": "phone"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.phone),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "phone", $$v)
            },
            expression: "editForm0.phone"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.modalType != 2) ? _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "姓名",
            "prop": "name"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.name),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "name", $$v)
            },
            expression: "editForm0.name"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "软件类型",
            "prop": "code"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          model: {
            value: (_vm.editForm0.code),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "code", $$v)
            },
            expression: "editForm0.code"
          }
        }, _vm._l((_vm.yhlx), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.text,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户类型",
            "prop": "userType"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          on: {
            "change": function (val) { return _vm.handerChange(val, 'addCode'); }
          },
          model: {
            value: (_vm.editForm0.userType),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "userType", $$v)
            },
            expression: "editForm0.userType"
          }
        }, [_c('el-option', {
          attrs: {
            "label": "个人用户",
            "value": "0"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": "企业用户",
            "value": "1"
          }
        })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户经理"
          }
        }, [_c('SelectCommon', {
          key: _vm.curCompanyId || _vm.addCode == 0,
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": true,
            "apiPath": "/tbAdminuser/manageList",
            "keys": {
              label: 'name',
              value: 'id'
            },
            "disabled": _vm.addCode == 1 || (_vm.addCode == 0 && _vm.userInfo.type != 1),
            "selectFirst": _vm.addCode == 1 && _vm.editForm0.companyuseid != '',
            "defaultVal": _vm.addCode == 0 && _vm.editForm0.managerAdminuser ?
              _vm.editForm0.managerAdminuser :
              '',
            "params": {
              ComId: _vm.addCode == 1 ? _vm.editForm0.companyuseid : '',
            }
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'managerAdminuser'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户成功经理"
          }
        }, [_c('SelectCommon', {
          key: _vm.curCompanyId || _vm.addCode == 0,
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": true,
            "apiPath": _vm.addCode == 1 ?
              '/tbAdminuser/getAdminUserByComId' :
              '/tbAdminuser/list',
            "params": _vm.addCode == 1 ?
              {
                userType: 3,
                ComId: _vm.addCode == 1 ? _vm.editForm0.companyuseid : '',
              } :
              {
                type: 3
              },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "disabled": _vm.addCode == 1 || (_vm.addCode == 0 && _vm.userInfo.type != 1),
            "selectFirst": _vm.addCode == 1 && _vm.editForm0.companyuseid != '',
            "defaultVal": _vm.addCode == 0 && _vm.editForm0.successfulManager ?
              _vm.editForm0.successfulManager :
              ''
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'successfulManager'); }
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "经销商"
          }
        }, [_c('SelectCommon', {
          key: _vm.curCompanyId || _vm.addCode == 0,
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": "请选择",
            "clearable": true,
            "apiPath": _vm.addCode == 1 ?
              '/tbAdminuser/getAdminUserByComId' :
              '/tbAdminuser/list',
            "params": _vm.addCode == 1 ?
              {
                userType: 4,
                ComId: _vm.addCode == 1 ? _vm.editForm0.companyuseid : '',
              } :
              {
                type: 4
              },
            "keys": {
              label: 'name',
              value: 'id'
            },
            "disabled": _vm.addCode == 1 || (_vm.addCode == 0 && _vm.userInfo.type != 1),
            "selectFirst": _vm.addCode == 1 && _vm.editForm0.companyuseid != '',
            "defaultVal": _vm.addCode == 0 && _vm.editForm0.agencyManager ?
              _vm.editForm0.agencyManager :
              ''
          },
          on: {
            "change": function (value, datas) { return _vm.handleSelectCommon(value, datas, 'agencyManager'); }
          }
        })], 1)], 1), _vm._v(" "), (_vm.addCode == 0) ? _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "所属企业",
            "prop": "company"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.company),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "company", $$v)
            },
            expression: "editForm0.company"
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addCode == 1) ? _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "所属企业",
            "prop": "companyuseid"
          }
        }, [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "filterable": ""
          },
          on: {
            "change": function (val) { return _vm.handerChange(val, 'curCompanyId'); }
          },
          model: {
            value: (_vm.editForm0.companyuseid),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "companyuseid", $$v)
            },
            expression: "editForm0.companyuseid"
          }
        }, _vm._l((_vm.companyList), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (
              _vm.editForm0.userType &&
              _vm.editForm0.userType == '1' &&
              _vm.modalType == '2'
            ),
            expression: "\n              editForm0.userType &&\n              editForm0.userType == '1' &&\n              modalType == '2'\n            "
          }],
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "部门"
          }
        }, [_c('el-select', {
          staticClass: "souch_change souch_input",
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "placeholder": "部门",
            "clearable": ""
          },
          model: {
            value: (_vm.deptId),
            callback: function($$v) {
              _vm.deptId = $$v
            },
            expression: "deptId"
          }
        }, _vm._l((_vm.detpList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.deptname,
              "value": item.id
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户地址",
            "prop": "longitudeAndLatitude"
          }
        }, [_c('GisCommon', {
          ref: "GisCommon",
          attrs: {
            "selected": _vm.editForm0.selected,
            "address": _vm.editForm0.address,
            "lonLat": _vm.editForm0.longitudeAndLatitude
          },
          on: {
            "backPram": _vm.backPram
          }
        })], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户密码",
            "prop": "passwordMo"
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入"
          },
          model: {
            value: (_vm.editForm0.passwordMo),
            callback: function($$v) {
              _vm.$set(_vm.editForm0, "passwordMo", $$v)
            },
            expression: "editForm0.passwordMo"
          }
        })], 1)], 1), _vm._v(" "), (_vm.modalType == 2) ? _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "文件",
            "prop": "fileUploadName"
          }
        }, [_c('el-button', {
          staticStyle: {
            "padding-left": "0",
            "padding-right": "0"
          },
          attrs: {
            "type": "primary"
          }
        }, [_c('label', {
          staticStyle: {
            "padding": "12px 20px",
            "cursor": "pointer"
          },
          attrs: {
            "for": "uploadwxsModal"
          }
        }, [_vm._v("选择文件")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.fileUploadName))])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              return _vm.cancelHandler.apply(null, arguments)
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), (_vm.modalType != 2) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading0
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit0('editForm0')
            }
          }
        }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (_vm.modalType == 2) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading0
          },
          nativeOn: {
            "click": function($event) {
              return _vm.importFile('editForm0')
            }
          }
        }, [_vm._v("提交")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "编辑",
            "visible": _vm.editFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "editForm",
          attrs: {
            "model": _vm.editForm,
            "label-width": "80px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "试用模块",
            "prop": "title"
          }
        }, [_c('div', {
          staticStyle: {
            "background": "rgb(244, 255, 243)",
            "width": "90%",
            "height": "300px",
            "overflow": "auto",
            "border": "1px solid #dfe6ec"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange
          },
          model: {
            value: (_vm.editForm.checkedCities),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "checkedCities", $$v)
            },
            expression: "editForm.checkedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticStyle: {
              "float": "left",
              "clear": "left",
              "margin-left": "20px",
              "position": "relative",
              "top": "0px"
            },
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "试用期限",
            "prop": "origin"
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.editForm.value),
            callback: function($$v) {
              _vm.$set(_vm.editForm, "value", $$v)
            },
            expression: "editForm.value"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          nativeOn: {
            "click": function($event) {
              _vm.editFormVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.editLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
          staticClass: "model-edit",
          attrs: {
            "title": "审批",
            "visible": _vm.appFormVisible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.appFormVisible = $event
            }
          }
        }, [_c('el-form', {
          ref: "appForm",
          attrs: {
            "model": _vm.appForm,
            "label-width": "80px"
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "试用模块",
            "prop": "title"
          }
        }, [_c('div', {
          staticStyle: {
            "background": "rgb(244, 255, 243)",
            "width": "90%",
            "height": "300px",
            "overflow": "auto"
          }
        }, [_c('el-checkbox-group', {
          on: {
            "change": _vm.handleCheckedCitiesChange
          },
          model: {
            value: (_vm.appForm.checkedCities),
            callback: function($$v) {
              _vm.$set(_vm.appForm, "checkedCities", $$v)
            },
            expression: "appForm.checkedCities"
          }
        }, _vm._l((_vm.cities), function(city) {
          return _c('el-checkbox', {
            key: city,
            staticStyle: {
              "float": "left",
              "clear": "left",
              "margin-left": "20px",
              "position": "relative",
              "top": "0px"
            },
            attrs: {
              "label": city
            }
          }, [_vm._v(_vm._s(city))])
        }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "试用期限",
            "prop": "origin"
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "请选择"
          },
          model: {
            value: (_vm.appForm.value),
            callback: function($$v) {
              _vm.$set(_vm.appForm, "value", $$v)
            },
            expression: "appForm.value"
          }
        }, _vm._l((_vm.options), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.label,
              "value": item.value
            }
          })
        }), 1)], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "dialog-footer",
          staticStyle: {
            "text-align": "center"
          },
          attrs: {
            "slot": "footer"
          },
          slot: "footer"
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.appLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.appSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("通过")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "loading": _vm.falseLoading
          },
          nativeOn: {
            "click": function($event) {
              return _vm.falseSubmit.apply(null, arguments)
            }
          }
        }, [_vm._v("驳回")])], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-194f4ae3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/account/Account.vue
// module id = 1771
// module chunks = 9